// extracted by mini-css-extract-plugin
module.exports = {"title-h1":"poll-info_title-h1__qtxI3","text":"poll-info_text__k-9vX"};